/*
 * bpmbuild-production.appspot.com
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.4.11-SNAPSHOT
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/StripeSubscriptionEventBean'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./StripeSubscriptionEventBean'));
  } else {
    // Browser globals (root is window)
    if (!root.BpmbuildProductionappspotcom) {
      root.BpmbuildProductionappspotcom = {};
    }
    root.BpmbuildProductionappspotcom.StripeSubscriptionEventBean = factory(root.BpmbuildProductionappspotcom.ApiClient, root.BpmbuildProductionappspotcom.StripeSubscriptionEventBean);
  }
}(this, function(ApiClient, StripeSubscriptionEventBean) {
  'use strict';

  /**
   * The StripeSubscriptionEventBean model module.
   * @module model/StripeSubscriptionEventBean
   * @version 1.0.0
   */

  /**
   * Constructs a new <code>StripeSubscriptionEventBean</code>.
   * @alias module:model/StripeSubscriptionEventBean
   * @class
   */
  var exports = function() {
  };

  /**
   * Constructs a <code>StripeSubscriptionEventBean</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/StripeSubscriptionEventBean} obj Optional instance to populate.
   * @return {module:model/StripeSubscriptionEventBean} The populated <code>StripeSubscriptionEventBean</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();
      if (data.hasOwnProperty('stripeType'))
        obj.stripeType = ApiClient.convertToType(data['stripeType'], 'String');
      if (data.hasOwnProperty('userId'))
        obj.userId = ApiClient.convertToType(data['userId'], 'String');
      if (data.hasOwnProperty('liveMode'))
        obj.liveMode = ApiClient.convertToType(data['liveMode'], 'Boolean');
      if (data.hasOwnProperty('lastUpdatedDateTime'))
        obj.lastUpdatedDateTime = ApiClient.convertToType(data['lastUpdatedDateTime'], 'Date');
      if (data.hasOwnProperty('stripeEventId'))
        obj.stripeEventId = ApiClient.convertToType(data['stripeEventId'], 'String');
      if (data.hasOwnProperty('beanInstance'))
        obj.beanInstance = StripeSubscriptionEventBean.constructFromObject(data['beanInstance']);
      if (data.hasOwnProperty('request'))
        obj.request = ApiClient.convertToType(data['request'], 'String');
      if (data.hasOwnProperty('created'))
        obj.created = ApiClient.convertToType(data['created'], 'Date');
      if (data.hasOwnProperty('codeTag'))
        obj.codeTag = ApiClient.convertToType(data['codeTag'], 'String');
      if (data.hasOwnProperty('pendingWebhooks'))
        obj.pendingWebhooks = ApiClient.convertToType(data['pendingWebhooks'], 'Number');
      if (data.hasOwnProperty('dateCreated'))
        obj.dateCreated = ApiClient.convertToType(data['dateCreated'], 'Date');
      if (data.hasOwnProperty('apiVersion'))
        obj.apiVersion = ApiClient.convertToType(data['apiVersion'], 'String');
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'String');
    }
    return obj;
  }

  /**
   * @member {String} stripeType
   */
  exports.prototype.stripeType = undefined;

  /**
   * @member {String} userId
   */
  exports.prototype.userId = undefined;

  /**
   * @member {Boolean} liveMode
   */
  exports.prototype.liveMode = undefined;

  /**
   * @member {Date} lastUpdatedDateTime
   */
  exports.prototype.lastUpdatedDateTime = undefined;

  /**
   * @member {String} stripeEventId
   */
  exports.prototype.stripeEventId = undefined;

  /**
   * @member {module:model/StripeSubscriptionEventBean} beanInstance
   */
  exports.prototype.beanInstance = undefined;

  /**
   * @member {String} request
   */
  exports.prototype.request = undefined;

  /**
   * @member {Date} created
   */
  exports.prototype.created = undefined;

  /**
   * @member {String} codeTag
   */
  exports.prototype.codeTag = undefined;

  /**
   * @member {Number} pendingWebhooks
   */
  exports.prototype.pendingWebhooks = undefined;

  /**
   * @member {Date} dateCreated
   */
  exports.prototype.dateCreated = undefined;

  /**
   * @member {String} apiVersion
   */
  exports.prototype.apiVersion = undefined;

  /**
   * @member {String} id
   */
  exports.prototype.id = undefined;

  return exports;

}));



// WEBPACK FOOTER //
// ./clientLibsProduction/src/model/StripeSubscriptionEventBean.js